<template>
  <div class="uebersicht">
    <div class="columns">
      <div class="column" style="text-align:left;">

        <b-message title="Systemzustand" type="is-danger" :closable="false" aria-close-label="Close message">

          <b-table :data="data2" :loading="loading" checkable hoverable>
            <template slot-scope="props">
              <b-table-column field="id" label="ID" sortable>
                {{ props.row.id }}
              </b-table-column>
              <b-table-column field="criticality" label="criticality" sortable>
                {{ props.row.criticality }}
              </b-table-column>
              <b-table-column field="message" label="Nachricht" sortable>
                {{ props.row.message }}
              </b-table-column>
              <b-table-column field="date" label="Datum" sortable>
                {{ formatDate(props.row.date) }}
              </b-table-column>

              <b-table-column width="115" custom-key="actions">

                <!--<button  style="border:0px;margin-right:7px;" class="button is-small" @click="copyItem(props.row)">
                <b-icon type="is-primary" icon="content-copy"></b-icon>
              </button>-->
                <button style="border:0px;" class="button is-small" @click="deleteItem(props.row)">
                  <b-icon type="is-danger" icon="delete"></b-icon>
                </button>
              </b-table-column>
            </template>

            <!--<template slot="detail" slot-scope="props">
              <tabledetail :row="props.row"></tabledetail>
            </template>-->

            <template slot="empty">
              <section class="section">
                <div class="content has-text-grey has-text-centered">
                  <p>
                    <b-icon
                        icon="emoticon-sad"
                        size="is-large">
                    </b-icon>
                  </p>
                  <p>Keine Warnungen gefunden.</p>
                </div>
              </section>
            </template>

          </b-table>
        </b-message>

        <b-message title="Überprüfung auf Bestellungen mit ungültigen Verpackungen" type="is-danger" :closable="false"
                   aria-close-label="Close message">
          <div style="color: #000;" v-html="data4"></div>
        </b-message>

        <b-message title="Überprüfung Material- und Produkt-Codes" type="is-danger" :closable="false"
                   aria-close-label="Close message">
          <div style="color: #000;" v-html="data3"></div>
        </b-message>

        <b-message title="Im Angebots-PDF ausgeblendete Preise" type="is-danger" :closable="false"
                   aria-close-label="Close message">
          <div style="color: #000; margin-bottom:20px;">
            <b>Für die folgenden Stückzahlen werden die Preise im Angebots-PDF ausgeblendet, weil das
              Produktionsverfahren mit der nächst niedrigeren Produktionszeit attraktivere Preise bietet.</b>
          </div>
          <div style="color: #000;" v-html="data"></div>
        </b-message>
      </div>
    </div>

  </div>
</template>

<script>
// @ is an alias to /src

const axios = require('axios');
var moment = require('moment');

export default {
  name: "warning",
  components: {
    //  HelloWorld
  },
  data() {
    return {
      search: "",
      loading: true,
      data: "",
      data2: [],
      data3: ""
    }
  },
  watch: {},
  mounted: function () {
    this.loadItems();
  },
  methods: {
    loadItems: function () {
      var _this = this;
      _this.loading = true;
      var loading1 = false;
      var loading2 = false;
      var loading3 = false;
      var loading4 = false;

      axios.get('/api/warnings/checkprices', {
        withCredentials: true,
      })
          .then(function (response) {
            console.log(response.data);
            loading1 = true;
            _this.data = response.data;
            if (loading1 && loading2 && loading3 && loading4) {
              _this.loading = false;
            }
          })
          .catch(function (error) {
            console.log(error);
            _this.loading = false;
          })
          .then(function () {
            // always executed
          });

      axios.get('/api/systemhealth', {
        withCredentials: true,
      })
          .then(function (response) {
            console.log(response.data);
            _this.data2 = response.data;
            loading2 = true;
            if (loading1 && loading2 && loading3 && loading4) {
              _this.loading = false;
            }
          })
          .catch(function (error) {
            console.log(error);
            _this.loading = false;
          })
          .then(function () {
            // always executed
          });

      axios.get('/api/warnings/checkzohocodes', {
        withCredentials: true,
      })
          .then(function (response) {
            console.log("ZOHO Codes Warning")
            console.log(response.data);
            _this.data3 = response.data;
            loading3 = true;
            if (loading1 && loading2 && loading3 && loading4) {
              _this.loading = false;
            }
          })
          .catch(function (error) {
            console.log(error);
            _this.loading = false;
          })
          .then(function () {
            // always executed
          });

      axios.get('/api/warnings/check-offers-for-missing-gamecombinations', {
        withCredentials: true,
      })
          .then(function (response) {
            console.log(response.data);
            loading4 = true;
            _this.data4 = response.data;
            if (loading1 && loading2 && loading3 && loading4) {
              _this.loading = false;
            }
          })
          .catch(function (error) {
            console.log(error);
            _this.loading = false;
          })
          .then(function () {
            // always executed
          });
    },

    deleteItem: function (item) {
      console.log("DELETE " + item.id);
      var vm = this;
      this.$buefy.dialog.confirm({
        title: 'Nachricht löschen',
        message: 'Soll die Nachricht wirklich gelöscht werden?',
        confirmText: 'Nachricht löschen',
        type: 'is-danger',
        hasIcon: true,
        cancelText: 'Abbrechen',
        onConfirm: function () {
          console.log(vm.search);
          axios.delete('/api/systemhealth/' + item.id, {
            withCredentials: true,
          })
              .then(function (response) {
                console.log(response.data);
                vm.$buefy.toast.open('Nachricht wurde gelöscht!');
                vm.loadItems();
              })
              .catch(function (error) {

              })
              .then(function () {
                // always executed
              });

        }

      })
    },

    formatDate: function (timestamp) {
      return moment(timestamp).format("DD.MM.YYYY HH:mm");
      //return new Date(timestamp).toLocaleDateString("de-DE")
    }

  }
};
</script>
